module.exports = __webpack_public_path__ + "static/trig_008-b1b7910ea41aa87514db3cb8e2bbf76d.webp";